<template>
<v-container fluid fill-height>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-menu :nudge-width="100">
                        <template v-slot:activator="{ on }">
                            <v-toolbar-title v-on="on" style="cursor: pointer;">
                                <span>{{selectedAssetType}}</span>
                                <v-icon dark>arrow_drop_down</v-icon>
                            </v-toolbar-title>
                        </template>
                        <v-list>
                        <v-list-tile
                            v-for="assetType in assetTypes"
                            :key="assetType"
                            @click="switchAssetType(assetType)"
                        >
                            <v-list-tile-title v-text="assetType"></v-list-tile-title>
                        </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-spacer></v-spacer>
                    <v-icon dark>layers</v-icon>
                </v-toolbar>
                <HMSKitTable v-if="selectedAssetType == 'HMS Kit'"></HMSKitTable>
                <BurroTable v-else></BurroTable>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import HMSKitTable from "@/components/configuration/assets/HMSKitTable.vue";
import BurroTable from "@/components/configuration/assets/BurroTable.vue";

export default {
    components: {
        HMSKitTable: HMSKitTable,
        BurroTable: BurroTable
    },
    data() {
        return {
            assetTypes: [
                'HMS Kit', 'Burro'
            ],
            selectedAssetType: 'HMS Kit',
        }
    },
    methods: {
        switchAssetType(assetType) {
            this.selectedAssetType = assetType;
        }
    },
}
</script>
